module.exports = __webpack_public_path__ + "img/10.fce66b85.png";